<div class="row">
  <p class="pad-bottom-20">{{ contactAdjusterSummary }}</p>
</div>
<div class="row">
  <form [formGroup]="contactAdjusterForm" (ngSubmit)="submit()">
    <section id="comments" class="column twelve pad-bottom-20">
      <p>{{ contactAdjusterCommentHeader }}</p>
      <div class="section-content">
        <div class="column twelve">
          <ds-form-control-container
            [labelText]="'Comments (max 850 characters)'"
            [control]="contactAdjusterForm.controls.commentInput"
          >
            <textarea
              id="commentInput"
              class="fill"
              formControlName="commentInput"
              rows="5"
              maxlength="850"
            ></textarea>
            <ds-form-control-message
              [control]="contactAdjusterForm.controls.commentInput"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>
    </section>
    <section id="contact-method" class="column twelve">
      <p class="heading-sub-page">{{ contactAdjusterEmailHeader }}</p>
      <div class="section-content">
        <div class="column twelve md-six">
          <ds-form-control-container
            [labelText]="'Email Address'"
            [control]="contactAdjusterForm.controls.emailInput"
          >
            <input type="text" id="emailInput" class="fill" formControlName="emailInput" />
            <ds-form-control-message
              [control]="contactAdjusterForm.controls.emailInput"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
        <div class="column twelve md-six md-pad-left-10">
          <ds-form-control-container
            [labelText]="'Phone Number'"
            [control]="contactAdjusterForm.controls.phoneInput"
          >
            <input
              [identifier]="'phoneInput'"
              id="phoneInput"
              [preValue]="contactAdjusterForm.value.phoneInput"
              [phoneControl]="contactAdjusterForm.controls['phoneInput']"
              formControlName="phoneInput"
              maxlength="12"
              dsPhoneMask
            />
            <ds-form-control-message
              [control]="contactAdjusterForm.controls.phoneInput"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>
    </section>
    <div class="column twelve callToAction">
      <span class="md-float-right">
        <a class="pad-horizontal-20" (click)="cancel()">Cancel</a>
        <button
          ds-button
          type="submit"
          class="-outline"
          [disabled]="
            contactAdjusterForm.invalid ||
            !(roleService.isAuthorized('contactadjfrm_submit') | async)
          "
        >
          Submit
        </button>
      </span>
    </div>
  </form>
</div>
